import { Component, Shark } from "shark-mvc";

import templateContent from "../../_shark_templates/components/breadcrumb.html";

class BreadcrumbComponent extends Component {
	constructor () {
		super("breadcrumbComponent");
		this.addTemplate("", templateContent);
	}
	

	beforeRender () {
		const subFolders = [];
		const folderBreadCrumb = Shark.get("documentsFolderBreadCrumb");
	
		this.set({
			folderBreadCrumb,
			breadcrumbActive: this.get("isActive"),
			subFolders,
		});
	}
	
	init () {
		this.set("isActive", false);
	}
}

const breadcrumbComponent = new BreadcrumbComponent();

Shark.registerComponent(breadcrumbComponent);

export { breadcrumbComponent };
